import { Stack } from '@mui/material';
import { FC } from 'react';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
export const CategoriesPageSkeleton: FC = () => {
  return (
    <Stack
        paddingLeft="10px"
        paddingRight="10px"
        gap="8px"
        style={{ height: '100%' }}
    >
        {Array.from({ length: 5 }).map((_, i) => (
            <ThemedSkeleton key={i} variant="rectangular" width="100%" height={60} sx={{
                borderRadius: '16px'
            }} />
        ))}
    </Stack>
  );
};

